class TextSvgSlider extends HTMLElement {
  connectedCallback() {
    if (this._swiper) return;
    const swiperEl = this.querySelector('.text-svg-slider__swiper');
    if (!swiperEl || typeof Swiper === 'undefined') return;

    this._swiper = new Swiper(swiperEl, {
      slidesPerView: 'auto',
      spaceBetween: 36,
      loop: true,
      speed: 6000,
      autoplay: { delay: 0, disableOnInteraction: false }
    });
  }

  disconnectedCallback() {
    if (this._swiper) {
      this._swiper.destroy(true, true);
      this._swiper = null;
    }
  }
}

if (!customElements.get('text-svg-slider')) {
  customElements.define('text-svg-slider', TextSvgSlider);
}
